import { render, staticRenderFns } from "./ViqConversationItem.vue?vue&type=template&id=8f880010&scoped=true"
import script from "./ViqConversationItem.vue?vue&type=script&lang=js"
export * from "./ViqConversationItem.vue?vue&type=script&lang=js"
import style0 from "./ViqConversationItem.vue?vue&type=style&index=0&id=8f880010&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f880010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f880010')) {
      api.createRecord('8f880010', component.options)
    } else {
      api.reload('8f880010', component.options)
    }
    module.hot.accept("./ViqConversationItem.vue?vue&type=template&id=8f880010&scoped=true", function () {
      api.rerender('8f880010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqConversationItem.vue"
export default component.exports